import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import classnames from 'classnames';
import { useStoreState, useStoreActions } from '../store';

export const ControlsOverlay = (props: any) => {
  const playbackControlsEnabled = useStoreState(state => state.config.playbackControlsEnabled);
  const playerReady = useStoreState(state => state.player.playerReady);
  const controlsVisible = useStoreState(state => state.player.controlsVisible);
  const casting = useStoreState(state => state.chromecast.casting);
  const playerActions = useStoreActions(actions => actions.player);

  // Remove control elements after fade-out transition, restore them when state changes.
  // This is ensure no cursor is seen after controls are hidden.
  const [shouldRender, setShouldRender] = useState(true);
  const handleTransitionEnd = () => setShouldRender(controlsVisible);
  useEffect(() => setShouldRender(true), [controlsVisible]);

  // For touch-screens, show controls before activating them
  function handleTouchEnd(e: React.TouchEvent<HTMLDivElement>) {
    if (!controlsVisible) {
      e.preventDefault();
      playerActions.setPlayerControlsVisible(true);
      e.target.dispatchEvent(new Event('mousemove', { bubbles: true }));
    }
  }

  return playbackControlsEnabled ? (
    <Container
      className={classnames({ visible: playerReady && (controlsVisible || casting) })}
      onTouchEnd={handleTouchEnd}
      onTransitionEnd={handleTransitionEnd}
    >
      {shouldRender && props.children}
    </Container>
  ) : null;
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 2px;
  background: linear-gradient(to bottom, rgba(0, 0, 0, 0.7) 1%, rgba(0, 0, 0, 0) 25%),
    linear-gradient(to bottom, rgba(0, 0, 0, 0) 49%, rgba(0, 0, 0, 0.7) 87%);
  transition: all 0.3s ease;
  opacity: 0;
  letter-spacing: 1px;

  &.visible {
    opacity: 1;
  }
`;
